module.exports = __webpack_public_path__ + "static/pc-d41149c1853ec3c0b51e648703ffe615.png";